import React from 'react';

// Components.
import { Card, CardBody, CardFooter, CardHeader }from 'reactstrap';
import AcknowledgementContent from './AcknowledgementContent';

function StepCard({ children, acknowledgements = [], acceptedAcknowledgements = [], headerContent, bodyClassName = '', toggleAcknowledgement = () => null }) {
  return (
    <Card className={`p-2 p-lg-4 text-secondary border-0 rounded-4 bg-darker-25 shadow surface-elevated panel-card`}>
      {headerContent && (
        <CardHeader className="d-flex gap-2 align-items-start border-0 pb-2">
          {headerContent}
        </CardHeader>
      )}

      {/* Main Content */}
      <CardBody className={`p-2 ${bodyClassName}`}>
        {children}
      </CardBody>

      {(acknowledgements.length > 0) && (
        <CardFooter className="border-0 pt-0">
          {acknowledgements.length > 0 && (
            <AcknowledgementContent
                acknowledgements={acknowledgements}
                acceptedAcknowledgements={acceptedAcknowledgements}
                toggleAcknowledgement={toggleAcknowledgement}
            />
          )}
        </CardFooter>
      )}
    </Card>
  );
}

export default StepCard;
